import { Image } from 'foundations-components/transitional/components/Image';
import { AgentInitialsIcon } from './internal/AgentInitialsIcon';
import { DefaultAgentIcon } from './internal/DefaultAgentIcon';

// --- AgentIconWithFallback Component ---
import { jsx as _jsx } from "react/jsx-runtime";
export const AgentIconWithFallback = ({
  size,
  name,
  iconUrl,
  marginBlockEnd = '400',
  borderRadius = 3,
  background = 'gradient'
}) => {
  if (typeof iconUrl === 'string' && iconUrl.length > 0) {
    return /*#__PURE__*/_jsx(Image, {
      alt: name,
      blockSize: `${size}px`,
      inlineSize: `${size}px`,
      marginBlockEnd: marginBlockEnd,
      shape: "rounded",
      src: iconUrl
    });
  }
  if (typeof name === 'string' && name.length > 0) {
    return /*#__PURE__*/_jsx(AgentInitialsIcon, {
      agentName: name,
      borderRadius: borderRadius,
      marginBlockEnd: marginBlockEnd,
      size: size,
      background: background
    });
  }
  return /*#__PURE__*/_jsx(DefaultAgentIcon, {
    marginBlockEnd: marginBlockEnd,
    size: size,
    background: background
  });
};